// extracted by mini-css-extract-plugin
module.exports = {"contents":"Kd-z","sectionHeading":"Ld-z"};